import SessionStorage from 'shared/helpers/sessionStorage';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/sessionStorage';

const RELATIVE_URL_BASE = 'https://chatwoot.local';
const EMBEDDED_ACCESS_TOKEN_QUERY_KEYS = [
  'api_access_token',
  'user_access_token',
];

const getWindowUrl = () => {
  return new URL(window.location.href, RELATIVE_URL_BASE);
};

const persistEmbeddedAccessToken = token => {
  if (token) {
    SessionStorage.set(SESSION_STORAGE_KEYS.EMBEDDED_API_ACCESS_TOKEN, token);
  }

  return token;
};

export const getEmbeddedAccessToken = () => {
  const url = getWindowUrl();
  const tokenFromQuery = EMBEDDED_ACCESS_TOKEN_QUERY_KEYS.find(queryKey =>
    url.searchParams.get(queryKey)
  );

  if (tokenFromQuery) {
    return persistEmbeddedAccessToken(url.searchParams.get(tokenFromQuery));
  }

  return SessionStorage.get(SESSION_STORAGE_KEYS.EMBEDDED_API_ACCESS_TOKEN);
};

export const hasEmbeddedAccessToken = () => {
  return !!getEmbeddedAccessToken();
};

export const clearEmbeddedAccessToken = () => {
  SessionStorage.remove(SESSION_STORAGE_KEYS.EMBEDDED_API_ACCESS_TOKEN);
};
